export function createWallQuestionConfig() {
	return {
		title: "Wall Question",
		instructions: "I’d like to know how you are feeling about the aphasia – your communication problem – what is it like for you these days.",
		administrationScript: "We sometimes use pictures, and this rating scale here, to help you show how you’re feeling.\n\nAt the right end, things are great. At the left end, things are not so great. Somewhere in the middle, things might feel so-so.\n\nLet’s try a practice question first: How are you feeling today? Point to a line on the scale for how you’re feeling. If it is not clear which line the person means, ask: ‘Just checking: Do you feel like you’re on this line, or on this line? Pick one.’ The practice choice is not the aphasia rating.\n\nI’d like to know how you are feeling about the aphasia – your communication problem – what is it like for you these days. For some people, aphasia can be like a wall. It can stop you from doing things, from joining in your life. In the middle, a ladder helps you climb over the wall. Things are getting better – maybe you are better at communicating or other people know how to talk to you. On the right, the wall is still there, but it is small and you are stepping over it to live your life. Aphasia is still there, but it does not stop you from doing what you want to do.\n\nWhich one is you?",
		pictureUrl: "/wall-question-pictograph.png",
		pictureDescription: "A large wall stops a person; a ladder helps a person over a wall; a person steps over a small wall.",
		unableLabel: "Unable to complete",
		historyLabel: "Earlier ratings",
		changeLabel: "Change since previous comparable rating",
		dateLabel: "Administration date",
		contextLabel: "Administration context",
		modeLabel: "Completion mode",
		ratingScaleMax: 4,
		allowEmptyFields: true,
		rejectEmptyFormSubmission: true,
		validateFormAnswers: true,
		contexts: [{id: "baseline", title: "Baseline"}, {id: "followUp", title: "Follow-up"}],
		contextId: "baseline",
		modes: [{id: "independent", title: "Independent"}, {id: "assisted", title: "Practitioner-assisted"}],
		modeId: "independent",
		discreteRating: {fieldId: "wallRating", construct: "Aphasia's overall impact on life"},
		fields: [{
			id: "wallRating", type: "SCALE", title: "Which one is you?", min: 0, max: 4,
			lowLabel: "Aphasia is a big problem", highLabel: "No problem", isRequired: false,
			answerOptions: Array.from({length: 9}, (_, index) => ({id: `position${index}`, title: String(index / 2), value: index / 2})),
		}],
	}
}

export function createWallQuestionDemoPayload() {
	return {answers: {wallRating: "position4"}, completionStatus: "rated", administrationDate: "2026-10-29"}
}

export function createWallQuestionDemoPriorResults() {
	const config = createWallQuestionConfig()
	return [
		{id: "prior-wall-1", toolType: "wallQuestion", createdAt: "2026-09-17", enginePayload: {form: config, answers: {wallRating: "position3"}, completionStatus: "rated", administrationDate: "2026-09-17"}},
		{id: "prior-wall-2", toolType: "wallQuestion", createdAt: "2026-10-06", enginePayload: {form: {...config, contextId: "followUp"}, answers: {wallRating: "position4"}, completionStatus: "rated", administrationDate: "2026-10-06"}},
	]
}
